import * as marietta from "../../marietta";

// GET /api/v1/webcad/lidar-data/{plan_id}

export class LiDARAPI {

    private url: string;
    private token: string;

    constructor(plan_id: string) {
        this.url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.domain}/api/v1/webcad/lidar-data/${plan_id}`;
        this.token = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.access_token}`;
    }

    public get(): Promise<any> { {
        console.log(`GET LiDAR-Data: ${this.url}`);
        // タイムアウトの設定
        const controller = new AbortController();
        const timeout = setTimeout(() => { controller.abort() }, 60000);    // 60秒でタイムアウト

        let fetch_get;
        
        // if (window.location.href.indexOf('localhost') > -1) {
        //     fetch_get = fetch('./assets/lidar/room.json', 
        //         {
        //             method: 'GET',
        //             mode: 'cors',
        //             cache: "no-store",
        //             signal: controller.signal })
        // } else {
            fetch_get = fetch(this.url, { method: 'GET',
            mode: 'cors',
            cache: "no-store",
            headers: {
               Authorization: this.token,
           },
            signal: controller.signal })
        // }

        return fetch_get.then((response) => {
                if (response.ok) {
                    return response.json();
                    // return response.text();
                }
                if (!response.ok) {
                    const object = response.json();
                    console.error('response.ok:', response.ok);
                    console.error('esponse.status:', response.status);
                    console.error('esponse.statusText:', response.statusText);
                    throw new Error(response.statusText);
                  }
                return Promise.reject(new Error(`${response.status}: ${response.statusText}`));
            })
            .catch((error) => {
                return Promise.reject(new Error(error));
            });
        }
    }
}